import type { IncidentStatus } from "@feedback-hub/contract/browser";

import { ADMIN_STATUS_LABELS } from "../format.js";

export function StatusBadge({ status }: { status: IncidentStatus }) {
  return <span className={`badge ${status}`}>{ADMIN_STATUS_LABELS[status]}</span>;
}
